import * as React from 'react';
import { Box, Container, Typography } from '@mui/material';

export default function Location() {

    return (  
        <Container sx={{ marginTop: 4, marginBottom: 4 }}>                               
            <Typography variant='h3' fontWeight={'bold'} sx={{ mb: 3, textAlign: 'center' }}>Ubicación</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <iframe title='Location' width="800" height="600" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3410.7548947360924!2d-61.54905932360969!3d-31.255207888479568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95caaefffa99c573%3A0x101d2f92ed420dde!2sOk%20Engineering%20S.a.!5e0!3m2!1sen!2sar!4v1736964155786!5m2!1sen!2sar"></iframe>
            </Box>
        </Container> 
    )
}
